




























































import { chunk } from 'lodash'
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { Profile } from '@/store/builder/types'
import { App } from '@/services/types'
import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderColorPicker from '@/components/builder/BuilderColorPicker.vue'
import BuilderSidebar from '@/components/builder/BuilderSidebar.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderColorSlider from '@/components/builder/BuilderColorSlider.vue'
import DescriptionMobileMenu from '@/components/DescriptionMobileMenu.vue'
import AppExampleDialogMessages from './components/AppExampleDialogMessages.vue'
@Component({
  components: {
    BuilderColorSlider,
    BuilderButton,
    BuilderTooltip,
    BuilderSidebar,
    BuilderColorPicker,
    BuilderDefaultContainer,
    AppExampleDialogMessages,
    DescriptionMobileMenu,
  },
  computed: {
    ...mapGetters('buildergpt', ['getCurrentStep', 'getApp']),
    ...mapState('app', ['showMenu']),
  },
  methods: {
    ...mapMutations('buildergpt', ['changeStep', 'setData']),
    ...mapActions('buildergpt', ['saveData']),
  },
  created() {
    this.$store.dispatch('app/changeVisibilityMenu', true)
  },
})
export default class Step1 extends Vue {
  @Prop({ default: true, type: Boolean }) loaded!: boolean
  showMenu: any
  setData!: any
  getCurrentStep!: number
  getApp!: any
  changeStep!: any
  saveData!: any
  stepData = {
    primaryColor: '',
  }
  processing = false

  app!: App | null

  profile!: Profile

  activeIndex = 0

  isSliderColor = false

  sliderColor = '#11AC86'

  pickerColor = '#11AC86'

  colors = [
    '#11AC86',
    '#779de9',
    '#27e2cc',
    '#A7A7A7',
    '#6A6A6A',
    '#DC61B2',
    '#EFDA1E',
    '#972ABD',
    '#BC6AE2',
    '#95E977',
    '#E9777E',
    '#E4AF70',
    '#A1AFCA',
    '#0757FA',
    '#8777E9',
    '#E2C1AE',
    '#FF3D00',
    '#E99A00',
  ]
  viewMode = false
  get position() {
    if (this.$breakpoints.desktop) {
      return 0
    }
    if (this.$breakpoints.tablet) {
      return 130
    }
    if (this.$breakpoints.mobileSmall) {
      return 15
    }
    if (this.$breakpoints.xs) {
      return 95
    }
    return 0
  }

  get color(): string {
    return this.isSliderColor ? this.sliderColor : this.pickerColor
  }

  @Watch('pickerColor', { immediate: true })
  onPickerColorChange(): void {
    this.isSliderColor = false
  }

  @Watch('sliderColor', { immediate: true })
  onSliderColorChange(): void {
    this.isSliderColor = true
  }

  get chunkedColors(): string[][] {
    return chunk(this.colors, 18)
  }

  async confirmStep(): Promise<void> {
    this.processing = true
    this.stepData.primaryColor = this.color
    await this.saveData(this.stepData)

    this.$router.push({ path: `/gpt/step/${this.getCurrentStep}` })
  }

  handlerClickBtnCloseMenu(): void {
    this.$store.dispatch('app/changeVisibilityMenu', false)
  }
  mounted() {
    localStorage.removeItem('API_TOKEN')
    localStorage.removeItem('CHAT_TOKEN')
    if (this.getApp.primaryColor) {
      this.pickerColor = this.getApp.primaryColor
    }
  }
}
